var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleDocs = function SvgGoogleDocs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.811,
    height: 40.988,
    viewBox: "0 0 29.811 40.988",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4285f4;\n      }\n\n      .cls-2 {\n        fill: #f1f1f1;\n      }\n\n      .cls-3 {\n        fill: #a1c2fa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google_Docs_Icon",
    "data-name": "Google Docs Icon",
    transform: "translate(-26.076 0.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2998",
    "data-name": "Group 2998",
    transform: "translate(26.076 -0.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4328",
    "data-name": "Path 4328",
    className: "cls-1",
    d: "M57.039-.32H41.2a2.865,2.865,0,0,0-2.794,2.8v35.4a2.866,2.866,0,0,0,2.8,2.8h24.22a2.866,2.866,0,0,0,2.8-2.8V10.858L61.7,6.2Z",
    transform: "translate(-38.408 0.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4329",
    "data-name": "Path 4329",
    className: "cls-2",
    d: "M51.817,45.873h14.9V44.011h-14.9l0,1.862Zm0,3.727H62.995V47.737H51.817V49.6Zm0-13.042V38.42h14.9V36.558Zm0,5.589h14.9V40.284h-14.9l0,1.862Z",
    transform: "translate(-44.365 -16.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4330",
    "data-name": "Path 4330",
    className: "cls-3",
    d: "M71.934-.32V8.065a2.864,2.864,0,0,0,2.794,2.794h8.384Z",
    transform: "translate(-53.303 0.32)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleDocs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-docs.c76b5e0fd762125a652e2a446cde6c45.svg";